import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  header: {
    flexWrap: 'nowrap',
    alignItems: 'center'
  },
  container: {
    position: 'relative',
    padding: 0
  },
  iconButtonRoot: {
    position: 'absolute',
    color: theme.colors.button__background_secondary,
    left: theme.spacing(-12),
    padding: 0
  },
  iconButtonLabel: {
    height: 48,
    width: 48
  },
  icon: {
    height: 48,
    width: 48,
    transform: 'rotate(180deg)'
  },
  rightLabel: {
    fontSize: 14,
    display: 'inline',
    marginRight: theme.spacing(2)
  },
  rightValue: {
    fontSize: 14,
    display: 'inline'
  },
  rightContainer: {
    padding: 0
  },
  link: {
    color: theme.palette.secondary.main,
    fontWeight: 500,
    '&:hover': {
      textDecoration: 'underline'
    }
  }
});

export default makeStyles(styles);
